import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import useStyles from './SpotlightBanner.styles';
import RichText from '../RichText/RichText';
const SpotlightBannerText = (props) => {
    const { classes } = useStyles();
    const { title, body } = props;
    return (_jsxs(_Fragment, { children: [!!title ? _jsx("h3", { className: classes.title, children: title }) : null, !!body ? _jsx(RichText, { content: body, className: classes.bodyText }) : null] }));
};
export default SpotlightBannerText;
